import { chandlerlimited } from "../data/brands/chandlerlimited";
import { empiricallabs } from "../data/brands/empiricallabs";
import { mother } from "../data/brands/mother";
import { prismsound } from "../data/brands/prismsound";
import { purpleaudio } from "../data/brands/purpleaudio";
import { radialengineering } from "../data/brands/radialengineering";
import { ssl } from "../data/brands/ssl";
import { tegeleraudio } from "../data/brands/tegeleraudio";
import { warmaudio } from "../data/brands/warmaudio";
import { wesaudio } from "../data/brands/wesaudio";

export const brands = {
  featured: [wesaudio, purpleaudio, empiricallabs, tegeleraudio, mother],
  others: [ssl, prismsound, chandlerlimited, radialengineering, warmaudio],
};

export const allBrands = [wesaudio, purpleaudio, empiricallabs, tegeleraudio, mother, ssl, prismsound, chandlerlimited, radialengineering, warmaudio];